export const UPLOAD_BULK_CUSTOMERS_LOCATION_REQUEST = 'UPLOAD_BULK_CUSTOMERS_LOCATION_REQUEST';
export const UPLOAD_BULK_CUSTOMERS_LOCATION_SUCCESS = 'UPLOAD_BULK_CUSTOMERS_LOCATION_SUCCESS';
export const UPLOAD_BULK_CUSTOMERS_LOCATION_FAILURE = 'UPLOAD_BULK_CUSTOMERS_LOCATION_FAILURE';
